import React, {useCallback, useEffect, useRef, useState} from "react";
import {observer} from 'mobx-react'
import useMyStores from "@/hooks/useMyStores.js";
import css from './home.module.scss'
import useFetchDefaultLive from "hooks/useFetchDefaultLive";
import Block1 from "./Block1";
import NavFloor from "./NavFloor";
import Footer from "./Footer";
import LoginFormPanel from "./LoginFormPanel";
import Center from "./Center";
import HomeAdvStore from "./store/HomeAdvStore";
import HomeSelfFloorStore from "./store/HomeSelfFloorStore";
import HomeFloorStore from "./store/HomeFloorStore";
import * as Api from 'api/api'
import HomeGuessYouLikeStore from "./store/HomeGuessYouLikeStore";
import GuessYouLike from "./GuessYouLike";
import LookAroundBlock from "./LookAroundBlock";
import HomeLookAroundStore from "./store/HomeLookAroundStore";
import IfLoading from "components/if-loading/IfLoading";
import HomeLazyLoadStore from "./store/HomeLazyLoadStore";
import {reaction, when} from "mobx";
import HomeAdv from "./HomeAdv";
import SelfFloor from "./SelfFloor";
import Floor from "./Floor";
import FloatMenu from "./FloatMenu";
import Service from "../../components/service/Service";
import Live from "../../components/live/live";
import liveStatusEnum from "../../enum/LiveStatusEnum";
import BlockAi from "pages/home/BlockAi.tsx";
import {Element, scroller, animateScroll} from 'react-scroll';
import {useScroll, useSize} from "ahooks";
import classNames from "classnames";


const advStore = new HomeAdvStore()
const selfFloorStore = new HomeSelfFloorStore()
const floorStore = new HomeFloorStore()
const guessYouLikeStore = new HomeGuessYouLikeStore();
const lookAroundStore = new HomeLookAroundStore()

const lazyLoadStore = new HomeLazyLoadStore()

// when(() => lazyLoadStore.adv1Flag, () => {
//     // 首页广告
//     Api.advImgList({}).then(list => {
//         advStore.setData({list})
//     })
// })
when(() => lazyLoadStore.selfFloorFlag, () => {
    // 自营楼层
    selfFloorStore.fetchData().then()
})
when(() => lazyLoadStore.floorFlag, () => {
    // 楼层
    floorStore.fetchData().then()
})
when(() => lazyLoadStore.guessYouLikeFlag, () => {
    // 猜你喜欢
    guessYouLikeStore.fetchData().then()
})
when(() => lazyLoadStore.lookAroundFlag, () => {
    // 随便看看
    lookAroundStore.fetchData().then()
})

// 这个是写直播间的时候临时为true
const devLive = false
// 这个是开发ai的时候临时设为true
const devAi = false;

function Home() {

    const {user: userStore, login: loginStore, app: appStore, service: serviceStore} = useMyStores();
    const {data: liveInfo} = useFetchDefaultLive()

    const refHome = useRef(null);
    const homeScroll = useScroll(refHome);
    const homeSize = useSize(refHome);
    const homeScrollToTop = () => {
        // 这里用 scroller 无效
        animateScroll.scrollToTop({
            containerId: 'glx-page-home',
            duration: 500,
            smooth: true,
        })
    }
    const scrollToAiBlock = () => {
        // 这里用 animateScroll 无效
        scroller.scrollTo("glx-ai-block", {
            containerId: 'glx-page-home',
            duration: 500,
            smooth: true,
            // offset: -20 // 可选：调整滚动位置，例如留出顶部导航栏的空间
        });
    };

    // useEffect(() => {
    //     console.log("homeScroll:",JSON.stringify(homeScroll))
    // }, [homeScroll?.top,homeScroll?.left]);
    // useEffect(() => {
    //     console.log("homeSize:",JSON.stringify(homeSize))
    // },[homeSize?.width,homeSize?.height]);

    const firstFetchData = useCallback(async () => {
        await appStore.fetchData()
    }, []);

    useEffect(() => {
        // 首页广告
        Api.advImgList({}).then(list => {
            advStore.setData({list})
        })
        firstFetchData().then(() => {
            lazyLoadStore.startLoadNext()
        })
    }, []);

    const [aiConfig, setAiConfig] = useState({})
    useEffect(() => {
        Api.aiConfig().then(data => {
            setAiConfig(data)
        })
    }, []);


    return (
        <div ref={refHome} id='glx-page-home' className={css.page}>
            {/* nav 搜索 banner 秒杀 */}
            {
                !devLive &&
                <Block1
                    aiConfig={aiConfig}
                    navFloor={<NavFloor/>}
                />
            }


            <Center className={classNames(css.center, aiConfig.open ? css.hasAi : css.normal)}>
                {
                    !devLive && aiConfig.open === true &&
                    <Element className={css.blockAiWrapper} name='glx-ai-block'>
                        <BlockAi aiConfig={aiConfig} scrollToAiBlock={scrollToAiBlock}/>
                    </Element>
                }

                {/* 广告1 */}
                {
                    !devLive && !aiConfig.open &&
                    <IfLoading
                        className={css.adv1Wrapper}
                        loadCondition={advStore.loading}
                        onLoad={() => {
                        }}
                    >
                        <HomeAdv className={css.adv1} adv={advStore.adv1}/>
                    </IfLoading>
                }

                {/* 自营楼层 */}
                {
                    !devLive && lazyLoadStore.selfFloorFlag &&
                    <IfLoading
                        className={css.selfFloorWrapper}
                        loadCondition={selfFloorStore.loading}
                        onLoad={() => lazyLoadStore.startLoadNext()}
                    >
                        <SelfFloor selfFloorStore={selfFloorStore}/>
                    </IfLoading>
                }

                {/*广告2*/}
                {
                    !devLive && !devAi && lazyLoadStore.adv2Flag &&
                    <IfLoading
                        className={css.adv2Wrapper}
                        loadCondition={advStore.loading}
                        onLoad={() => lazyLoadStore.startLoadNext()}
                    >
                        <HomeAdv className={css.adv2} adv={advStore.adv2}/>
                    </IfLoading>
                }

                {/* 楼层 */}
                {
                    !devLive && !devAi && lazyLoadStore.floorFlag &&
                    <IfLoading
                        className={css.floorListWrapper}
                        loadCondition={floorStore.loading}
                        onLoad={() => lazyLoadStore.startLoadNext()}
                    >
                        {
                            floorStore.list.map((item, i) => {
                                return (
                                    <Floor key={i} data={item} className={css.floor}/>
                                )
                            })
                        }
                    </IfLoading>
                }

                {/* 猜你喜欢 */}
                {
                    !devLive && !devAi && lazyLoadStore.guessYouLikeFlag &&
                    <IfLoading
                        className={css.guessYouLikeWrapper}
                        loadCondition={guessYouLikeStore.loading}
                        onLoad={() => {
                            lazyLoadStore.startLoadNext()
                        }}
                    >
                        <GuessYouLike goodsList={guessYouLikeStore.list}/>
                    </IfLoading>
                }

                {/* 随便看看 */}
                {
                    !devLive && !devAi &&
                    <IfLoading
                        className={css.lookAroundBlockWrapper}
                        loadCondition={lookAroundStore.notFetch}
                        onLoad={() => lazyLoadStore.startLoadNext()}
                    >
                        <LookAroundBlock
                            // lookAroundStore={lookAroundStore}
                            loadMoreData={async ()=>{
                                await lookAroundStore.fetchData()
                            }}
                            loading={lookAroundStore.loading}
                            canLoadMoreData={lookAroundStore.canLoadMoreData}
                            list={lookAroundStore.list}
                            homeScroll={homeScroll}
                            homeSize={homeSize}
                        />
                    </IfLoading>
                }
            </Center>

            <Footer/>

            {/*直播间*/}
            {
                liveInfo?.live.status === liveStatusEnum.OPEN &&
                <Live
                    containerClassName={css.liveContainer}
                    userStore={userStore}
                    loginStore={loginStore}
                    liveInfo={liveInfo}
                />
            }

            {/* 悬浮菜单 */}
            <div className={css.floatMenuContainer}>
                <FloatMenu homeScroll={homeScroll} homeScrollToTop={homeScrollToTop} homeSize={homeSize}
                           floorIds={floorStore.floorIds}/>
            </div>

            {/* 客服 */}
            {serviceStore.show && (
                <div className={css.serviceContainer}>
                    <div className={css.main}>
                        <Service/>
                    </div>
                </div>
            )}

            {
                loginStore.show &&
                <LoginFormPanel/>
            }
        </div>
    )
}

export default observer(Home)
